import { render, staticRenderFns } from "./gImgList.vue?vue&type=template&id=2cfb0e07&scoped=true&"
import script from "./gImgList.vue?vue&type=script&lang=js&"
export * from "./gImgList.vue?vue&type=script&lang=js&"
import style0 from "./gImgList.vue?vue&type=style&index=0&id=2cfb0e07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb0e07",
  null
  
)

export default component.exports